module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [(_vm.hasSlot('heading')) ? _c('div', {
    staticClass: "panel-heading"
  }, [_vm._t("heading")], 2) : _vm._e(), _vm._v(" "), (_vm.hasSlot('body')) ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._t("body")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c44d2206"}!./src/app/components/panel/panel.html
// module id = 499
// module chunks = 1